module.exports = __webpack_public_path__ + "img/OVCA_Plasma.49e092b2.png";